<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('applicationDetail.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form
            :canEdit="canEdit"
            ref="baseForm"
            @setOriginalCurrencyCode="setOriginalCurrencyCode"
            :type="$route.query.type"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('issuingDetail.collapseTitle.issuingInfo') }}
          </div>
        </template>
        <div class="collapse-content">
          <issuing-form :canEdit="canEdit" ref="issuingForm" :type="$route.query.type" />
        </div>
      </el-collapse-item>

      <el-row>
        <el-col :span="24">
          <el-tabs class="addSupplyChain" type="border-card">
            <!-- 合同信息 -->
            <el-tab-pane :label="$t('issuingDetail.collapseTitle.contractDetail')">
              <goods-table :canEdit="canEdit" ref="goodsTable" :type="$route.query.type" />
            </el-tab-pane>
            <!-- 会计凭证 -->
            <!-- <el-tab-pane :label="$t('issuingDetail.collapseTitle.accountingDoc')"> </el-tab-pane> -->
          </el-tabs>
        </el-col>
      </el-row>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('applicationDetail.collapseTitle.fileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <upload
            :isShow="false"
            ref="upload"
            defaultPath="scm/applicationForCredit"
            :tableData="fundAttachmentList"
            @upload="uploadList"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 修改 -->
      <el-button
        type="primary"
        @click="edit()"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042917082023059']"
        >{{ this.$t('applicationDetail.btnList.edit') }}</el-button
      >
      <!-- 保存 -->
      <el-button
        type="primary"
        :disabled="!canEdit"
        @click="save('004')"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042917084223847']"
        >{{ this.$t('applicationDetail.btnList.save') }}</el-button
      >
      <!-- 提交（完成开征） -->
      <el-button
        type="primary"
        @click="save('005')"
        :disabled="!canEdit"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042917102178319']"
        >{{ this.$t('issuingDetail.btnList.submit') }}</el-button
      >
      <!-- 撤回 撤销 -->
      <el-button
        type="primary"
        :disabled="baseData.statusFlag != '004'"
        @click="revoke()"
        :loading="load"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042917105847859']"
        >{{ this.$t('applicationDetail.btnList.revoke') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseForm from '../components/applicationForm'; // 基本信息
  import IssuingForm from '../components/issuingForm'; // 开证信息
  import GoodsTable from '../components/applicationTable'; // 合同信息表格
  // import GOODS_API from '@/api/masterData/goods';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  // import DELIVERY_API from '@/api/logisticsCenter/transportOrder';
  // import MASTER_API from '@/api/masterData/company.js';
  import API from '@/api/capitalCenter/letterOfCredit';
  import Upload from '@/components/upload';
  // import { resolve, reject } from 'q';

  export default {
    name: 'issuingLC',
    components: {
      BaseForm,
      GoodsTable,
      Upload,
      IssuingForm,
    },
    data() {
      return {
        status: '',
        load: false,
        activeNames: ['1', '2', '3'],
        componentsList: ['baseForm', 'goodsTable'],
        fundAttachmentList: [],
        baseData: { statusFlag: null },
        allDetail: '',
        exchangeLadingNo: '', //附件列表
        canEdit: this.$route.query.isEdit == 'Y',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.getDetail();
    },
    methods: {
      // 撤销--返回已保存状态
      revoke() {
        this.$confirmAction(
          this.$t('issuingDetail.msg.confirmRevoke'),
          this.$t('issuingDetail.msg.confirmRevoke')
        )
          .then(() => {
            let params = { id: this.baseData.id };
            this.loading.startLoading();
            this.$axios.post(API.REVOKE_CREDITLETTER, params).then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('issuingDetail.msg.revokeSussess'),
                  type: 'success',
                });
                this.goNewPage();
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //checkbox需将字符串转boolean
      changeBoolean() {
        this.allDetail.isIndependent = this.allDetail.isIndependent == '1';
        this.allDetail.isForeignParent = this.allDetail.isForeignParent == '1';
        this.allDetail.isRefundMargin = this.allDetail.isRefundMargin == '1';
      },
      setOriginalCurrencyCode(code) {
        this.$refs.issuingForm.originalCurrencyCode = code;
      },
      // 请求详情
      getDetail() {
        this.loading.startLoading();
        const params = {
          id: this.$route.query.applicationId,
        };
        this.$axios.post(API.QUERY_CREDITLETTER_BY_ID, params).then((res) => {
          if (res.data.code == 0) {
            this.loading.endLoading();
            this.status = res.data.data.returnStatus;
            this.allDetail = res.data.data;
            this.baseData = res.data.data;
            this.changeBoolean();
            if (!this.baseData.clCode) {
              this.baseData.marginCurrencyCode = this.baseData.currencyCode;
              this.baseData.marginExchangeRate = this.baseData.applyExchangeRate;
              this.baseData.clAmount = this.baseData.applyClAmount;
              this.baseData.clStandardAmount = this.baseData.applyClStandardAmount;
            }
            this.fundAttachmentList = this.allDetail.returnAttachmentList;
            this.$refs.baseForm.getDetail(this.allDetail);
            this.$refs.goodsTable.getDetail(this.allDetail);
            this.$refs.issuingForm.getDetail(this.allDetail);
          }
        });
      },
      edit() {
        this.canEdit = !this.canEdit;
      },
      save(btnType) {
        let params = {};
        // let sign = true;
        if (btnType == '004' || btnType == '005') {
          this.$refs['issuingForm'].exportChildData(btnType).then(() => {
            params = { ...this.$refs['issuingForm'].formData };
            this.saveData(btnType, params);
          });
        } else if (btnType == '006') {
          this.$confirmAction(this.$t('issuingDetail.msg.confirmCancel'))
            .then(() => {
              this.saveData(btnType, this.allDetail);
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
          // this.componentsList.some(item => {
          //   let momentObj = this.$refs[item].exportChildData(btnType);
          //   params = Object.assign(params, momentObj);
          // });
          // this.saveData(btnType, params);
        }
      },
      saveData(btnType, params) {
        console.log(params, 'params');
        this.loading.startLoading();
        params.sourceType = '1';
        params.statusFlag = btnType;
        params = this.$baseRequest.assignObj(params);
        params.isIndependent = params.isIndependent ? '1' : '0';
        params.isForeignParent = params.isForeignParent ? '1' : '0';
        params.isRefundMargin = params.isRefundMargin ? '1' : '0';
        // params.contractList[0]
        // 保存提交
        this.$axios.post(API.OPERA_CREDITLETTER, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.allDetail = res.data.data;
            this.changeBoolean();
            this.$refs['baseForm'].baseData = this.allDetail;
            this.$refs['issuingForm'].baseData = this.allDetail;
            if (btnType == '004') {
              this.$message({
                showClose: true,
                message: this.$t('issuingDetail.msg.saveSussess'),
                type: 'success',
              });
              this.getDetail();
            } else if (btnType == '005') {
              this.$message({
                showClose: true,
                message: this.$t('issuingDetail.msg.submitSussess'),
                type: 'success',
              });
              this.goNewPage();
            } else if (btnType == '006') {
              this.$message({
                showClose: true,
                message: this.$t('issuingDetail.msg.cancelSussess'),
                type: 'success',
              });
              this.goNewPage();
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //更新附件列表
      uploadList(value) {
        this.attachments = [];
        if (value.length) {
          value.map((item, index) => {
            this.attachments.push({
              ...item,
              sortNo: index,
            });
          });
        }
      },
      goNewPage() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/letterOfCredit/searchIssueCredit',
            name: 'searchIssueCredit',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
